import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

interface ShareButtonProps {
  title: string;
  text: string;
  url?: string;
  className?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({
                                                   title,
                                                   text,
                                                   url = window.location.href,
                                                   className = ''
                                                 }) => {
  const {t} = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleShare = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering parent click handlers (like navigating to details)

    // 1. Try the Native Web Share API first
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url,
        });
      } catch (error) {
        console.log('Error sharing:', error);
      }
    }
    // 2. Fallback: Copy to Clipboard
    else {
      try {
        await navigator.clipboard.writeText(url);
        setIsCopied(true);

        // Reset the "Copied" status after 2 seconds
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`${className} transition-all duration-200`}
      title={isCopied ? t('common.linkCopied') : t('gallery.item.share')}
    >
      {isCopied ? (
        <i className="fa fa-check"/>
      ) : (
        <i className="fa fa-share-nodes"/>
      )}
    </button>
  );
};

export default ShareButton;
